<template>
  <div class="page-content">
    <page-template
      ref="manageTable"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
    <el-dialog title="设备激活信息" :visible.sync="activeShow" width="600px" class="active-dialog" @close="closeDialog">
      <div class="image-preview">
        <el-form ref="form" :model="form" :show-message="false" :rules="rules" label-width="80px" v-loading="loading">
          <el-col :span="24">
            <el-form-item label='设备SN' prop="deviceInfo">
              <el-input v-model="form.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label='商户号' prop="mchntNo">
              <el-input v-model="form.mchntNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label='详细地址' prop="address">
              <el-input type="textarea" v-model="form.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="dialog-footer" style="margin: 10px 0;">
              <el-button type='primary' @click="save" size="mini">保存</el-button>
              <el-button type='default' @click="closeDialog" size="mini">取消</el-button>
            </div>
          </el-col>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  components: {
    pageTemplate

  },
  data() {
    return {
      loading:false,
      mchntName:"",
      activeShow:false,
      form:{
        deviceInfo:'',
        mchntNo:'',
        address:'',
      },
      rules:{
        address:[{required:true,message:"请输入地址",trigger:"blur"}]
      },
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            isHasAll: true,
            data: [],
            url: api.system.seStore
          },
          {
            label: '设备名称/编码',
            type: 'input',
            prop: 'otherName',
            placeholder: '请输入设备名称/编码',
            isFuzzy: true
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          filter:()=>{
            return false
          },
        },
        {
          label: '激活',
          code: 'activate',
          callback:this.activate,//serialNum
          filter:(data)=>{
            return data.serialNum?false:true
          },
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          filter:()=>{
            return false
          },
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          filter:()=>{
            return false
          },
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true, //是否显示索引
        columns: [
          // {label: '消费门店', prop: 'storeId', width: '120', align: 'center'},
          {label: '所属门店', prop: 'storeName', width: '100', align: 'center'},
          {label: '设备唯一码', prop: 'sn', width: '180', align: 'center'},
          {
            label: '设备状态',
            prop: 'status',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('seDevice.status')
          },
          {
            label: "在线状态",
            prop: "deviceStatus",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus("seDevice.deviceStatus"),
          },
          {label: '采集码', prop: 'serialNum', width: '160', align: 'center'},
          {label: '登记时间', prop: 'createDttm', width: '140', align: 'center'},
          {label: '登记人', prop: 'createByDesc', width: '100', align: 'center'},
          {label: '设备类型', prop: 'name', width: '100', align: 'center'},
          {
            label: '平台类型',
            prop: 'type',
            width: '100',
            enumData: this.$utils.getCacheStatus("seDevice.type"),
            align: 'center'
          },
          {
            label: '是否开启收银',
            type: 'switch',
            prop: 'openCashier',
            width: '140',
            align: 'center',
            change:this.changeOpenCashier,
          },
          {
            label: '是否允许充值',
            type: 'switch',
            prop: 'openRecharge',
            width: '140',
            align: 'center',
            change:this.changeOpenRecharge,
          },
          {
            label: '是否接收订单',
            type: 'switch',
            prop: 'openMallMessage',
            width: '140',
            align: 'center',
            change:this.changeOpenMallMessage,
          },
        ],
        url: api.store.device
      },
      // 添加字段
      addColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '设备名称',
            type: 'input',
            prop: 'name',
            placeholder: "请输入设备名称",
            rule: [
              {required: true, message: '请输入设备名称', trigger: 'blur'},
            ],
          },
          {
            label: '设备编码',
            type: 'input',
            prop: 'code',
            placeholder: "请输入设备编码",
            rule: [
              {required: true, message: '请输入设备编码', trigger: 'blur'},
            ],
          },
          {
            label: '采购员',
            type: 'input',
            prop: 'buyer',
            placeholder: "请输入采购员",
            rule: [
              {required: true, message: '请输入采购员', trigger: 'blur'},
            ],
          },
          {
            label: '采购员手机号',
            type: 'input',
            prop: 'buyerPhone',
            placeholder: "请输入采购员手机号",
            maxLength: 11,
            rule: [
              {required: true, message: '请输入采购员手机号', trigger: 'blur'},
              {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
            ],
          },
          {
            label: '设备型号',
            type: 'select',
            data: [],
            url: api.store.deviceCategory,
            prop: 'deviceCategoryId',
            rule: [
              {required: true, message: '请选择设备型号', trigger: 'blur'},
            ],
          },
          {
            label: '设备SN',
            type: 'input',
            prop: 'sn',
            placeholder: "请输入设备类型编码",
            rule: [
              {required: true, message: '请输入设备类型编码', trigger: 'blur'},
            ],
          },
          {
            label: '备注',
            type: 'textarea',
            span: 22,
            prop: 'remarks'
          },

        ], // 表单label
        url: api.store.device
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
    // this.setSupplier(this.searchOptions.simple);
  },
  methods: {
    // 激活保存
    save(){
      this.$refs.form.validate(valid=>{
        if(valid){
          this.$loading({})
          this.$axios.fetchPost(api.baseInfo.collectActive,this.form).then(res=>{
            if(res.code == 200 && res.data){
              this.activeShow = false
              this.$notify({
                type: "success",
                title: '激活操作',
                message: '成功',
                showClose: false,
              });
              // this.$message.success('激活成功')
              this.$refs.manageTable.operationSuccess()
            }else{
              this.$notify({
                type: "error",
                title: '激活操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error(res.errorMsg || '保存失败')
            }
          }).finally(()=>{
            this.$loading({}).close()
          })
        }else{
          return false
        }
      })
    },
    //关闭激活
    closeDialog(){
      this.activeShow = false
      this.form = {
        deviceInfo:'',
        mchntNo:'',
        address:'',
      }
      this.$refs.form.resetFields()
    },
    // 打开激活
    activate(row){
      //console.log(row)
      this.activeShow = true
      this.form.deviceInfo = row.code
      this.form.id = row.id
      this.$axios.fetchPost(api.baseInfo.collectAddress,{}).then(res=>{
        if(res.code == 200 && res.data){
          this.form.address = res.data
        }else{
          this.$message.error(res.errorMsg || '查询地址失败')
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    // 是否开启收银
    changeOpenCashier(row){
      let param = {id:row.id,openCashier:row.openCashier}
      this.saveData('修改收银状态？确认',param)
    },
    //是否允许充值
    changeOpenRecharge(row){
      let param = {id:row.id,openRecharge:row.openRecharge}
      this.saveData('修改允许充值状态？确认',param)
    },
    // 是否接受订单
    changeOpenMallMessage(row){
      let param = {id:row.id,openMallMessage:row.openMallMessage}
      this.saveData('修改接受订单状态？确认',param)
    },
    saveData(tip,param){
      this.$confirm(tip).then(()=>{
        this.$loading({text:'请求中，请稍后。。。'})
        this.$axios.fetchPut(api.store.device,param).then(res=>{
          if(res.code === 200){
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message.success('修改成功')
          }else{
            this.$notify({
              type: "error",
              title: '修改操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error(res.errorMsg || '修改失败')
          }
        }).finally(()=>{
          this.$loading({}).close()
          this.$refs.manageTable.operationSuccess()
        })
      }).catch(_ => {
        this.$refs.manageTable.operationSuccess()
      });
    },
  }
};
</script>

<style scoped>
.active-dialog >>> .el-dialog{
  min-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/page/store/device/Mgmt.vue